import CreateVsFixEncsPerMonthChart from './EncCharts/CreateVsFixEncsPerMonthChart/CreateVsFixEncsPerMonthChart';
import PestsVsSightingsChart from './EncCharts/PestsVsSightingsChart/PestsVsSightingsChart';
import UniquePestsPerDayChart from './EncCharts/UniquePestsPerDayChart/uniquePestsPerDayChart';
import UniqueTracesPerDayChart from './EncCharts/UniqueTracesPerDayChart/UniqueTracesPerDayChart';

interface PageProps {
  slug: string;
}

const SightsPage: React.FC<PageProps> = ({ slug }) => {
  return (
    <>
      <div className="row my-3">
        <div className="col-xxl-6 my-2">
          <UniquePestsPerDayChart slug={slug} />
        </div>
        <div className="col-xxl-6 my-2">
          <UniqueTracesPerDayChart slug={slug} />
        </div>
      </div>
      <div className="row">
        <div className="col-xxl-6 my-2">
          <CreateVsFixEncsPerMonthChart slug={slug} />
        </div>
        <div className="col-xxl-6 my-2">
          <PestsVsSightingsChart slug={slug} />
        </div>
      </div>
    </>
  );
};

export default SightsPage;
